import { GlobalResponseObject } from "../../../global-response-object";
import { RootWiseCostModel } from "./root-wise-cost.model";

export class RootwiseCostResponseModel extends GlobalResponseObject {
    // data?: RootWiseCostModel[];
    data?: any;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: any) {
        super(status, intlCode, internalMessage);
        this.data = data;
}
}

